var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,0a12,12,0,0,0,0,24c4.38,0,6-1.64,6.55-3a3.92,3.92,0,0,0,.06-2.9l.33-.34a2.17,2.17,0,0,0,.66-1.44,2,2,0,0,0-.54-1.45l-1.55-1.54a2,2,0,0,0-2.89.11l-.26.25a30.69,30.69,0,0,1-4-4l.25-.26a2.05,2.05,0,0,0,.12-2.89L9.15,4.94A1.91,1.91,0,0,0,7.7,4.4a2.22,2.22,0,0,0-1.44.66L5.31,6A2.91,2.91,0,0,0,4.8,9.55a31.08,31.08,0,0,0,9.65,9.65,2.59,2.59,0,0,0,1.4.4,3.05,3.05,0,0,0,2-.75,3.06,3.06,0,0,1-.26,1.94C16.81,22.24,14.9,23,12,23a11,11,0,1,1,9.08-4.78.5.5,0,1,0,.82.56A12,12,0,0,0,12,0Zm3,18.35A30,30,0,0,1,5.65,9,1.89,1.89,0,0,1,6,6.71l1-.94a1.2,1.2,0,0,1,.78-.37h.06a.89.89,0,0,1,.63.25L10,7.2a1.05,1.05,0,0,1-.12,1.47l-.57.58a.49.49,0,0,0,0,.66,31.51,31.51,0,0,0,4.83,4.83.49.49,0,0,0,.66,0l.58-.57A1.05,1.05,0,0,1,16.8,14l1.55,1.55a.94.94,0,0,1,.25.69,1.24,1.24,0,0,1-.37.79l-.94.94A1.87,1.87,0,0,1,15,18.35Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.8d2851db85b638a10491153567073d99.svg";
export { ForwardRef as ReactComponent };